var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-link not-printable",attrs:{"href":_vm.url}},[_c('span',{staticClass:"glyphicon cars_compare_glyphicon cars_compare_glyphicon__megaphone"}),_vm._v(" Get Similar Vehicle Alerts ")])}
var staticRenderFns = []

export { render, staticRenderFns }